import {
  SESSION_LAST_ACTIVITY_STORAGE_KEY,
  SESSION_LAST_API_REQUEST_STORAGE_KEY,
} from "@/constants/session";

const ACTIVITY_EXCLUDED_PATH_PREFIXES = [
  "/v1/auth/",
  "/v1/assessment/presence/heartbeat",
  "/v1/proofreading/",
];

function readTimestamp(key: string): number | null {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem(key);
    if (raw === null) return null;
    const value = Number(raw);
    return Number.isFinite(value) ? value : null;
  } catch {
    return null;
  }
}

function writeTimestamp(key: string, value: number): boolean {
  if (typeof window === "undefined") return false;

  try {
    window.localStorage.setItem(key, String(value));
    return true;
  } catch {
    return false;
  }
}

export function isActivityTrackedPath(path: string): boolean {
  return !ACTIVITY_EXCLUDED_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}

export function markUserActivity(at: number = Date.now()) {
  writeTimestamp(SESSION_LAST_ACTIVITY_STORAGE_KEY, at);
}

export function readLastUserActivity(): number | null {
  return readTimestamp(SESSION_LAST_ACTIVITY_STORAGE_KEY);
}

export function recordApiActivity(path: string, at: number = Date.now()) {
  if (!isActivityTrackedPath(path)) return;
  writeTimestamp(SESSION_LAST_API_REQUEST_STORAGE_KEY, at);
}

export function readLastApiActivity(): number | null {
  return readTimestamp(SESSION_LAST_API_REQUEST_STORAGE_KEY);
}
